// Usadas quando a API de categorias não responde.
export const FALLBACK_CATEGORY_LABELS = [
  'Limpeza & Organização',
  'Reparos & Reformas',
  'Elétrica',
  'Hidráulica',
  'Pintura',
  'Jardinagem',
  'Construção',
  'Assistência Técnica',
  'Montagem de Móveis',
  'Ar-condicionado',
  'Mudanças & Fretes',
  'Serviços Gerais',
];
